import { createFileRoute } from '@tanstack/react-router';
import IphonePage from '@/pages/static/IphonePage';

export const Route = createFileRoute('/iphone')({
  component: IphonePage,
});
